/* eslint-disable @typescript-eslint/no-explicit-any */
import { createAuthInterceptor } from '@lib/authInterceptor'; // Import the auth interceptor
import type { AsyncThunk, AsyncThunkAction, PayloadAction } from '@reduxjs/toolkit';
import Axios from 'axios';
import { setupCache } from 'axios-cache-interceptor';
import type { NavigateFunction } from 'react-router';

export const baseURL = import.meta.env.VITE_BACKEND_URL || '/api/v1';

export const axiosClientNoCache = Axios.create({
  baseURL,
  headers: {
    'X-Requested-With': 'XMLHttpRequest',
  },
  withCredentials: true,
});

const axiosClientCached = setupCache(axiosClientNoCache);

// Add the auth interceptor for 401 handling
const authInterceptor = createAuthInterceptor();
axiosClientCached.interceptors.response.use(authInterceptor.onFulfilled, authInterceptor.onRejected);
axiosClientNoCache.interceptors.response.use(authInterceptor.onFulfilled, authInterceptor.onRejected);

export const csrf = async () => {
  await axiosClientCached.get('/sanctum/csrf-cookie');
};

export const routeOnFulfilled = async (
  navigate: NavigateFunction,
  route: string,

  resultAction: AsyncThunkAction<any, any, any> | PayloadAction<any>,

  asyncThunk: AsyncThunk<any, any, any>,
) => {
  if (asyncThunk.fulfilled.match(resultAction)) {
    navigate(route);
  }
};

export const checkIfActionFulfilled = async (
  resultAction: AsyncThunkAction<any, any, any> | PayloadAction<any>,

  asyncThunk: AsyncThunk<any, any, any>,
) => asyncThunk.fulfilled.match(resultAction);

export const checkIfActionRejected = async (
  resultAction: AsyncThunkAction<any, any, any> | PayloadAction<any>,
  asyncThunk: AsyncThunk<any, any, any>,
) => asyncThunk.rejected.match(resultAction);

export default axiosClientCached;
